<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { usePageStore } from '../../stores/page'
import { useConfigStore } from '../../stores/config'

const { pageData } = storeToRefs(usePageStore())
const { rsConfig } = storeToRefs(useConfigStore())

const showFooterSeoHeadline = computed(() =>
  !!pageData.value?.body?.headline && pageData.value?.pageMeta?.url === '/' && !!rsConfig.value.isSeoHeadlineEnabled
)
</script>

<template>
  <div v-if="showFooterSeoHeadline"
       class="bx-js-seo-headline bx-footer__seo-headline-wrapper">
    <h1 class="bx-footer__seo-headline">
      {{ pageData?.body?.headline }}
    </h1>
  </div>
</template>
